import DashboardView from '../../../components/DashboardView/DashboardView';

// Dashboard do superadmin (/dashboard). Reutiliza a vista partilhada; o
// seletor de grupo mostra todos os grupos (accessibleGroups = todos p/ super).
export default function Dashboard() {
  return <DashboardView unansweredTo="/unanswered" sessionDetailsTo="/sessions" />;
}
